import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from '../../ui/navigation-menu';
import { Home, MessageSquare, Heart, Users, Megaphone } from 'lucide-react';
import NavMenuItem from './NavMenuItem';

/**
 * Authenticated desktop navigation dropdowns (Feed + My Pets + Discover +
 * Community + More + Feedback).
 */
export default function DesktopAuthNav({ filteredNavGroups, isActive, isGroupActive }) {
  const location = useLocation();

  const dropdowns = [
    { key: 'myPets', icon: Heart, label: 'My Pets', testid: 'nav-my-pets-dropdown', gridCols: 'md:grid-cols-2', width: 'w-[380px] md:w-[420px]' },
    { key: 'community', icon: Users, label: 'Community', testid: 'nav-community-dropdown', gridCols: 'md:grid-cols-2', width: 'w-[400px] md:w-[500px]' },
    { key: 'more', icon: Megaphone, label: 'More', testid: 'nav-more-dropdown', gridCols: '', width: 'w-[320px]' },
  ];

  return (
    <NavigationMenu className="hidden lg:flex">
      <NavigationMenuList>
        {/* Feed — direct link */}
        <NavigationMenuItem>
          <Link
            to="/feed"
            className={`group inline-flex h-10 w-max items-center justify-center rounded-md px-4 py-2 text-sm font-medium transition-colors text-white/85 hover:bg-white/10 hover:text-white focus:bg-white/10 focus:text-white ${
              isActive('/feed') ? 'bg-white/15 text-white' : ''
            }`}
            data-testid="nav-feed"
          >
            <Home className="w-4 h-4 mr-2" />
            Feed
          </Link>
        </NavigationMenuItem>

        {/* Dropdown groups */}
        {dropdowns.map(({ key, icon: Icon, label, testid, gridCols, width }) => {
          const group = filteredNavGroups[key];
          if (!group) return null;
          return (
            <NavigationMenuItem key={key}>
              <NavigationMenuTrigger
                className={`bg-transparent text-white/85 hover:bg-white/10 hover:text-white focus:bg-white/10 focus:text-white data-[state=open]:bg-white/15 data-[state=open]:text-white ${isGroupActive(group) ? 'bg-white/15 text-white' : ''}`}
                data-testid={testid}
              >
                <Icon className="w-4 h-4 mr-2" />
                {label}
              </NavigationMenuTrigger>
              <NavigationMenuContent>
                <ul className={`grid ${width} gap-1 p-2 ${gridCols}`}>
                  {group.items.map((item) => (
                    <li key={item.href}>
                      <NavigationMenuLink asChild>
                        <NavMenuItem item={item} />
                      </NavigationMenuLink>
                    </li>
                  ))}
                </ul>
              </NavigationMenuContent>
            </NavigationMenuItem>
          );
        })}

        {/* Feedback — direct link */}
        <NavigationMenuItem>
          <Link
            to={`/beta-feedback?from=${encodeURIComponent(location.pathname)}`}
            className={`group inline-flex h-10 w-max items-center justify-center rounded-md px-4 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground ${
              isActive('/beta-feedback') ? 'bg-accent text-accent-foreground' : ''
            }`}
            data-testid="nav-beta-feedback"
          >
            <MessageSquare className="h-4 w-4 mr-2" />
            Feedback
          </Link>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
}
